var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zi-progress-bar",class:_vm.fix},[_c('div',{staticClass:"zi-progress"},[_c('div',{staticClass:"zi-progress__inner",class:_vm.type,style:(_vm.styles)})])])}
var staticRenderFns = []

export { render, staticRenderFns }